import { Controller } from "@hotwired/stimulus"
import { createConsumer } from "@rails/actioncable"

export default class extends Controller {
  static targets = ["dot"]

  connect() {
    this.consumer = createConsumer()
    this.subscription = this.consumer.subscriptions.create(
      { channel: "ClientStatusChannel" },
      {
        received: (data) => this.handleMessage(data),
      },
    )
    this.offlineTimeout = null
  }

  disconnect() {
    this.clearOfflineTimeout()
    if (this.subscription) {
      this.subscription.unsubscribe()
      this.subscription = null
    }
    if (this.consumer) {
      this.consumer.disconnect()
      this.consumer = null
    }
  }

  handleMessage(data) {
    switch (data.type) {
      case "heartbeat":
        this.setOnline()
        this.resetOfflineTimeout()
        break
      case "ingest":
        this.pulse()
        break
    }
  }

  setOnline() {
    this.dotTargets.forEach((dot) => {
      dot.classList.remove("bg-gray-300")
      dot.classList.add("bg-live")
    })
  }

  setOffline() {
    this.dotTargets.forEach((dot) => {
      dot.classList.remove("bg-live")
      dot.classList.add("bg-gray-300")
    })
  }

  pulse() {
    this.dotTargets.forEach((dot) => {
      dot.classList.remove("animate-pulse-dot")
      // Force reflow to restart animation
      void dot.offsetWidth
      dot.classList.add("animate-pulse-dot")
      dot.addEventListener(
        "animationend",
        () => dot.classList.remove("animate-pulse-dot"),
        { once: true },
      )
    })
  }

  resetOfflineTimeout() {
    this.clearOfflineTimeout()
    this.offlineTimeout = setTimeout(() => this.setOffline(), 90_000)
  }

  clearOfflineTimeout() {
    if (this.offlineTimeout) {
      clearTimeout(this.offlineTimeout)
      this.offlineTimeout = null
    }
  }
}
